import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global styles
import './styles/globals.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <App />
);